// import '../lib/zepto/zepto';
// import '../lib/zepto/callbacks';
// import '../lib/zepto/defered';
// import '../lib/zepto/fx';

import '../lib/events';
import '../lib/url';
import '../lib/cache';
// import '../lib/m-base';
// import '../lib/fastclick';
// FastClick.attach(document.body);

import './global';
import '../lib/loading';
import '../lib/native';
import '../lib/notification';
import '../lang/index';



// WEBPACK FOOTER //
// ./js/component/openjs/uph5/seed.js